import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';
import { Theme } from '@material-ui/core/styles/createTheme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      fontSize: '12pt',
      margin: theme.spacing(2, 0, 2, 0),
      color: theme.palette.common.black,
      '&.inLines': {
        marginBottom: theme.spacing(1),
        padding: theme.spacing(0, 0.5),
      },
    },
  }),
);

export default useStyles;
